import React from 'react';
import {Helmet} from 'react-helmet';
import styles from './Help.module.css';
import SectionCard from '../patterns/SectionCard';
import useSmartBack from '../app-shell/useSmartBack';

// Local to this page, matching the "Back" link built for Videos.js.
const BackArrowIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props}>
        <path d="M19 12H5M11 6l-6 6 6 6"/>
    </svg>
);

const Help = () => {
    const goBack = useSmartBack();

    return (
        <div className={styles.root}>
            <Helmet>
                <title>Ovalview | Help</title>
            </Helmet>
            <div className={styles.page}>
                <button type="button" className={styles.backLink} onClick={goBack}>
                    <BackArrowIcon/>Back
                </button>

                <div className={styles.header}>
                    <p className={styles.eyebrow}>HELP</p>
                    <h1 className={styles.title}>Help</h1>
                    <p className={styles.subtitle}>Some pointers toward unlocking the productivity features.</p>
                </div>

                <div className={styles.grid}>
                    <SectionCard title="Organisations">
                        <p className={styles.body}>
                            It's all about the org! Creating an org unlocks user collaboration, folders and
                            Jira integration.
                        </p>
                        <p className={styles.body}>
                            Click the <strong>Org</strong> menu to get started - name your org and invite
                            existing Ovalview users.
                        </p>
                    </SectionCard>

                    <SectionCard title="Jira integration">
                        <p className={styles.body}>
                            Create a user in Jira (or use an existing one), then create an API key for that user.
                        </p>
                        <p className={styles.body}>
                            Enable it by configuring Jira from the <strong>Org</strong> menu.
                        </p>
                        <img src="/siteimages/jira-tickets.png" alt="Ovalview tasks synced to Jira tickets" className={styles.image}/>
                    </SectionCard>

                    <SectionCard title="Folders">
                        <p className={styles.body}>
                            Organise and group your pages using folders. Pages in a folder are accessible to
                            everyone in your org; pages in the Private folder are only accessible by you.
                        </p>
                        <p className={styles.body}>
                            Create folders from the <strong>Org</strong> menu.
                        </p>
                        <img src="/siteimages/docId.png" alt="Choosing a folder for a page" className={styles.image}/>
                    </SectionCard>

                    <SectionCard title="User collaboration">
                        <p className={styles.body}>
                            Share pages with your team by inviting existing Ovalview users to your org from
                            the <strong>Org</strong> menu.
                        </p>
                        <img src="/siteimages/addusers.png" alt="Adding a user to an org" className={styles.image}/>
                    </SectionCard>
                </div>
            </div>
        </div>
    );
};

export default Help;
